import { onUnmounted, watchEffect } from 'vue';

const useAnchor = () => {
  const resizeWindow = () => {
    const quickLocate = document.querySelector('.append') as HTMLElement;
    const windowWidth = document.documentElement.clientWidth;
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollBottom = scrollHeight - windowHeight - scrollTop;
    const originalBottom = windowWidth > 1280 ? 7 : 7.5;

    if (quickLocate?.classList.value.includes('append_progress')) {
      if (scrollTop < 400 && scrollBottom > 300) {
        quickLocate.style.top = `${7 - scrollTop / 100}rem`;
        return;
      }
    }

    if (quickLocate?.classList.value.includes('__append_with_overview')) {
      if (scrollTop < 450 && scrollBottom > 300) {
        quickLocate.style.top = `${originalBottom - scrollTop / 100}rem`;
        return;
      }
      if (scrollTop >= 450 && scrollBottom > 300) {
        quickLocate.style.top = '1.5rem';
        return;
      }
    }

    if (quickLocate?.classList.value.includes('__append_glossary')) {
      if (scrollTop < 450 && scrollBottom > 300) {
        quickLocate.style.top = `${5 - scrollTop / 100}rem`;
        return;
      }
    }

    if (quickLocate) {
      if (scrollBottom < 300) {
        quickLocate.style.top = 'unset';
        quickLocate.style.bottom = `${3.5 - scrollBottom / 100}rem`;
      } else if (quickLocate?.classList.value.includes('__normal_progress')) {
        quickLocate.style.top = '5rem';
      }
    }
  };

  watchEffect(() => {
    const initScroll = () => {
      try {
        setTimeout(() => {
          window.addEventListener('scroll', resizeWindow, true);
        }, 100);
      } catch (e) {
        console.error(e);
      }
    };

    initScroll();
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', resizeWindow);
  });
};

export default useAnchor;
